import { useReactiveFeatureFlagValue } from '@/app/contexts';

/**
 * Create-case UI needs two LaunchDarkly flags (TR-4241 / TR-4384):
 *
 * - `case-creation-flows` (`caseCreationFlows`) — the product switch.
 * - `casesFromPermissionService` — the case list must come from
 *   permission-service, which returns the new case immediately. The provenance
 *   list does not include an empty case.
 *
 * Both must be literal `true`. Anything else hides the entry points.
 */
export const CASE_CREATION_FLOWS_FLAG_KEY = 'case-creation-flows';
export const CASE_CREATION_FLOWS_FLAG_CAMEL = 'caseCreationFlows';
export const CASES_FROM_PERMISSION_SERVICE_FLAG = 'casesFromPermissionService';

export function isCaseCreationFlowsEnabled(
  caseCreationFlows: unknown,
  casesFromPermissionService: unknown,
): boolean {
  return caseCreationFlows === true && casesFromPermissionService === true;
}

export function useCaseCreationFlowsFlagValue(): unknown {
  const camel = useReactiveFeatureFlagValue(CASE_CREATION_FLOWS_FLAG_CAMEL);
  const kebab = useReactiveFeatureFlagValue(CASE_CREATION_FLOWS_FLAG_KEY);
  return camel ?? kebab;
}

export function useCaseCreationFlowsEnabled(): boolean {
  const casesFromPermissionService = useReactiveFeatureFlagValue(CASES_FROM_PERMISSION_SERVICE_FLAG);
  return isCaseCreationFlowsEnabled(useCaseCreationFlowsFlagValue(), casesFromPermissionService);
}
